<template>
 <div class="field">
    <div class="control">
        <div>
            <input
                @change="$emit('input', value)"
                :checked="checked === value"
                :id="id"
                :name="name"
                type="radio"/>
            <label :for="id">
                <slot/>
            </label>
        </div>
        <p class="help">
            <slot name="description" />
        </p>
    </div>
</div>
</template>

<script>
export default {
    name: 'Radio',
    model: {
        prop: 'checked'
    },
    props: ['checked', 'value', 'name'],
    data: vm => ({
        id: vm.createRandomId()
    }),
    methods: {
        createRandomId () {
            const len = 10
            return [...Array(len)].map(() => Math.random().toString(36)[2]).join('')
        }
    }
}
</script>

<style lang="scss" scoped>
// Circle checkbox is too close to the label.
label {
    padding-left: 6px;
}
</style>
